<!-- 学员管理 -->
<template>
  <div class="basicStyle">
    <div class="bg_fff">
      <div class="querySearch"> 
        <div class="searchItem">
          <span>用户信息</span>
          <el-input class="w300" v-model="queryInfo.keyword" clearable size="small" placeholder=请输入学员登录账号/真实姓名/手机号></el-input>
        </div>
        <div class="searchItem">
          <span>身份证</span>
          <el-input class="w180" v-model="queryInfo.id_card" clearable size="small" placeholder=请输入身份证></el-input>
        </div>
        <div class="searchItem">
          <span>状态</span> 
          <el-select
            v-model="queryInfo.status"
            placeholder="请选择"
            filterable
          > 
            <el-option
              v-for="item in statusOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />  
          </el-select> 
        </div>
        <div class="searchItem">
          <span>已开通商品</span>
          <el-select v-model="queryInfo.tob_good_id" filterable size="small" :clearable="true">
            <el-option
                  v-for="(item, index) in options"
                  :key="index"
                  :label="item.good_name +'（'+ item.relation_id + '）'"
                  :value="item.tob_good_id"
                >
            </el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>学员标签</span> 
          <el-select
            v-model="queryInfo.tag_id"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="getTobSearchTags"
            :loading="loading"
            :clearable="true"
            size="mini"
          >
            <el-option
              v-for="(item, index) in options1"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div v-if="show_student_active_status == 1" class="searchItem">
          <span>学员激活状态</span>
          <el-select v-model="queryInfo.open_status" size="small" :clearable="true">
            <el-option
              v-for="item  in options2"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>创建时间</span>
          <el-date-picker
            v-model="timeFrame"
            size="small"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            @change="selectData"
            clearable
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div> 
        <div v-if="options3.length > 1" class="searchItem">
          <span>所属考试产品</span>
          <el-select v-model="app_keys" size="small"  multiple
            collapse-tags clearable>
            <el-option
              v-for="item  in options3"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option> 
          </el-select>
        </div>
        <div class="searchItem">
          <span>添加方式</span>
          <el-select v-model="queryInfo.add_type" size="small" clearable> 
            <el-option
              v-for="item  in add_type_list"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>  
          </el-select>
        </div> 
        <div class="searchItem">
          <span>备注</span>
          <el-input class="w180" v-model="queryInfo.remark" clearable size="small" placeholder=请输入备注></el-input>
        </div>
        <div class="searchItem">
          <span>创建人</span>
          <el-select
            style="width: 220px"
            v-model="create_user"
            filterable
            placeholder="请输入创建人名字"
            multiple
            collapse-tags
            remote
            reserve-keyword
            :remote-method="debounce(getTobSearchCreateUser, 500)"
            @clear="createUserOptions = []"
            clearable
          >
            <el-option
              v-for="item in createUserOptions"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select> 
        </div>
        <div v-if="is_update_student_teacher" class="searchItem">
          <span>关联老师</span>           
          <el-select 
           v-model="queryInfo.teacher_name" 
           placeholder="请选择关联老师"
           size="small"
           filterable
           clearable>
            <el-option
              v-for="item  in allTeacherList"
              :key="item.id"
              :label="item.realname"
              :value="item.id"
            >
            </el-option> 
          </el-select>
        </div>
        <MyButton value="搜索" icon="el-icon-search" type="1" @click="queryTable"></MyButton>
        <MyButton value="重置" type="2" @click="resetQuery"></MyButton> 
      </div>
      <div class="addInfo">
        添加学员方式：
        <MyButton value="手动添加学员" size="medium" type="3" @click="viewDetail()"></MyButton>
        <MyButton value="批量导入学员" size="medium" type="3" @click="openImport"></MyButton>
        <div style="display:inline-block;position: relative;"> 
          <MyButton value="招生表单链接邀请" size="medium" type="3" @click="studentInvite"></MyButton>
          <span 
          @click="studentInvite"
          style="
            display: block;
            position: absolute;
            font-size: 15px;
            left: 105px;
            top: -10px;
            background: red;
            color: #fff;
            padding: 2px 5px;
            border-radius: 5px;
            cursor: pointer;
          ">推荐</span>
        </div>
        <div class="appRegister" >
          <div class="registerH1">APP邀请码：{{group_id}} </div>
          <div class="registerH2"  @click="copy(group_id)">点击复制
            <el-popover placement="right"  width="600" trigger="hover">
              <div>
                <iframe
                :src="firstSrc"
                :width="firstWidth"
                :height="firstHeight"
                frameborder="0"
                allowfullscreen
                />
              </div> 
              <i class="el-icon--right el-icon-question" slot="reference"></i>
            </el-popover> 
          </div>
        </div>
        <div style="float:right;line-height:40px;margin: 0 50px 10px 0;">
          <MyButton
            v-if="role == 'admin'||role == 'generaladministrato'"
            value="导出学员"
            size="medium"
            type="1"
            @click="downloadExcel"
          ></MyButton>
          <el-popover placement="bottom" trigger="click" v-model="revealVisible" style="float:right">
            <div>
              <p>可勾掉不需要显示的列表数据</p>
              <el-checkbox
                v-model="checkAll"
                :indeterminate="isIndeterminate"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="popoverChecked"
                @change="handleCheckedCitiesChange"
              >
                <el-checkbox
                  v-for="item in popoverOptions"
                  :key="item.field"
                  style="display: block"
                  :label="item.field"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>

              <div slot="footer" class="dialog-footer" style="margin-top: 20px"> 
                <MyButton value="取 消" size="mini" type="2" @click="revealVisible = false"></MyButton>
                <MyButton value="确 定" size="mini" type="1" @click="confirm"></MyButton>
              </div>
            </div>
            <el-button slot="reference" class="revealBtn">显示列表设置</el-button>  
          </el-popover>    
          
          <!-- APP邀请码：{{group_id}} 
          <span class="operationItemNew liberalColor" style="line-height:25px;" @click="copy(group_id)">复制</span>
          <el-popover placement="left"  width="600" trigger="hover">
            <div>
              <iframe
              :src="firstSrc"
              :width="firstWidth"
              :height="firstHeight"
              frameborder="0"
              allowfullscreen
              />
            </div>
            <i class="el-icon--right questionIcon" slot="reference"></i>
          </el-popover>  -->
        </div> 
        </div> 
      <div  ref="tableBox" class="table table_box" >  
        <el-table
          ref="tableRef"
          :data="tableList"
          style="width: 100%"
          border 
          :row-class-name="tableRowClassName"
          @selection-change="handleSelectionChange"
        >   
          <!-- :disabled="allStatus" -->
          <el-table-column  v-if="queryInfo.status==1"  type="selection" width="55" align="center" :selectable="selectable" />
          <el-table-column 
            v-if="allSelfShowFieldMap.get('uid')"
            prop="uid"
            label="学员ID"
            align="center"
          >
            <template slot-scope="scope">
               {{ scope.row.uid }}
            </template>
          </el-table-column>
          <el-table-column v-if="allSelfShowFieldMap.get('username')" prop="username" label="学员登录账号" align="center" />
          <el-table-column v-if="allSelfShowFieldMap.get('realname')" prop="realname" label="真实姓名" align="center" />
          <el-table-column v-if="allSelfShowFieldMap.get('mobile')" prop="mobile" label="手机号" align="center" /> 
          <el-table-column 
            v-if="allSelfShowFieldMap.get('add_type')"
            prop="add_type"
            label="添加方式"
            align="center"
          >
            <template slot-scope="scope"> 
              {{ scope.row.add_type_name }} 
            </template>
          </el-table-column>
          <el-table-column v-if="allSelfShowFieldMap.get('id_card')" prop="id_card" label="身份证" align="center" />
          <el-table-column v-if="allSelfShowFieldMap.get('app_names') && options3 && options3.length > 1" prop="app_names" label="开通考试类别" align="center" /> 
          <el-table-column 
            v-if="allSelfShowFieldMap.get('courses')"
            prop="courses"
            label="已开通商品"
            align="center"
            width="160"
          >
            <template slot-scope="scope"> 
             <div v-if="scope.row.courses && scope.row.courses.length>0"> 
              {{scope.row.courses.toString()}} 
             </div>
            </template>
          </el-table-column>
          <el-table-column v-if="show_student_active_status == 1 && allSelfShowFieldMap.get('active_status_txt')" prop="active_status_txt" label="学员激活状态" 
            :render-header="renderHeader" align="center" width="140" />
          <el-table-column v-if="show_student_active_status == 1 && allSelfShowFieldMap.get('active_at')" prop="active_at" label="激活时间" align="center" /> 
          <el-table-column 
            v-if="allSelfShowFieldMap.get('tags')"
            prop="tags"
            label="学员标签"
            align="center"
            width="200"
          >
            <template slot-scope="scope"> 
              <el-popover
              placement="right"
              trigger="hover"
              v-if="scope.row.tags.length>3"
              >
              <div style="width:200px">
                <el-tag v-for="(item,index) in scope.row.tags" :key="index" style="margin:5px">{{item}}</el-tag>
              </div>
              <div slot="reference">
                <el-tag v-for="(item,index) in scope.row.tags" :key="index" style="margin:5px" v-show="index<3">{{item}}</el-tag>
                ...
              </div>
            </el-popover>
            <div v-else>
              <el-tag v-for="(item,index) in scope.row.tags" :key="index" style="margin:5px">{{item}}</el-tag>
            </div>
            </template>
          </el-table-column>
          <el-table-column v-if="allSelfShowFieldMap.get('create_user')" prop="create_user" label="创建人" align="center" />
          <el-table-column
            v-if="allSelfShowFieldMap.get('student_teachers')"
            prop="student_teachers"
            label="关联老师"
            align="center" 
            width="200"
          >
            <template slot-scope="scope">   
              <div v-if="scope.row.student_teachers.length>0">
                <div v-for="(item,index) in scope.row.student_teachers" :key="index" style="margin-bottom:5px">
                  {{item.teacher_name}} | ID{{item.teacher_id}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="allSelfShowFieldMap.get('created_at')" prop="created_at" label="创建时间" align="center" />
          <el-table-column v-if="allSelfShowFieldMap.get('update_user')" prop="update_user" label="更新人" align="center" />
          <el-table-column v-if="allSelfShowFieldMap.get('updated_at')" prop="updated_at" label="更新时间" align="center" />
          <el-table-column  
            v-if="allSelfShowFieldMap.get('status')"
            prop="status"
            label="帐号状态"
            align="center"
            width="200"
          >
            <template slot-scope="scope">   
               {{scope.row.status_name}} 
            </template>
          </el-table-column>
          <el-table-column v-if="allSelfShowFieldMap.get('remark')" prop="remark" label="备注" align="center" /> 
          <el-table-column prop="operation" label="操作" align="center" :width="operationWidth" fixed="right">
            <template slot-scope="scope">
              <!-- <div v-if="scope.row.status==2">
                该学员已注销
              </div>  -->
              <div v-if="scope.row.status==4">
                该学员已删除
              </div> 
              <div v-else-if="scope.row.is_can_operation==0">
                <!-- 无操作权限 -->
                {{scope.row.operation_remark}} 
              </div> 
              <div v-else>  
                <div style="display: inline-block;" v-if="scope.row.is_can_open_good==1 && !isSalespersonr">
                  <div @click="buyGoodsBtn(scope.row)" class="xyxq" >开通商品</div> 
                </div>
                <div class="czbt" v-if="scope.row.is_can_open_good == 0 && !isSalespersonr"> 
                  <span class="kaitong">开通</span> 
                </div>
                <span v-if="!isSalespersonr" style="color:#E7EAF0;padding:0 10px;">|</span>
                <el-popover
                  placement="bottom"
                  trigger="hover"
                  popper-class="accountManage">
                  <div>
                    <div @click="viewDetail(scope.row)" class="hoverRed">编辑</div>
                    <div @click="editLabel(scope.row)" class="hoverRed">添加标签</div>
                    <div @click="restartCode(scope.row)" v-if="!isSalespersonr" class="hoverRed">重置密码</div>
                    <div @click="resetCode(scope.row)" v-if="!isSalespersonr" class="hoverRed">修改密码</div>
                    <div @click="disableCode(scope.row)" v-if="scope.row.is_can_disable" class="hoverRed">禁用</div> 
                    <div @click="deleteCode(scope.row)" v-if="scope.row.is_can_delete" class="hoverRed">删除</div> 
                  </div>
                  <span slot="reference" class="operationItem editColor">修改</span>
                </el-popover> 
                <span class="fg">|</span> 
                <div class="czbt">
                  <div @click="studentDetails(scope.row)" class="xyxq">详情</div> 
                </div>
              </div> 
            </template>
          </el-table-column>
        </el-table>

        <div class="page_box">
          <div v-if="queryInfo.status==1&&queryInfo.total>0"> 
            <el-checkbox
              v-model="allSelectedStatus"
              @change="allSelected"
              style="margin-right: 20px;"
            >当前页</el-checkbox>

            <el-checkbox
              v-model="allStatus" 
              @change="allStatusChange"
              style="margin-right: 20px;"
            > 
               {{ allStatusText }}
            </el-checkbox> 
            <!-- v-if="selectedList.length>0||allStatus" -->
            <el-button type="text" @click="associateTeacher(1)">关联老师</el-button>
            <el-button type="text" @click="associateTeacher(2)">取消关联</el-button>
            <span v-if="role == 'admin'||role == 'generaladministrato'">
              <el-button type="text" @click="batchOperation()">禁用/删除</el-button>
            </span>
            <el-button type="text" @click="associateTeacher(3)">添加标签</el-button>
          </div>

          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="queryInfo.page"
              :page-sizes="[10, 30, 50, 80]"
              :page-size="queryInfo.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="queryInfo.total">
            </el-pagination>
          </div>
        </div> 

      <div ref="topScroll" class="top-scroll">
        <div class="top-scroll-content" :style="{ width: topScrollWidth }" />
      </div>
      </div>
    </div>
    <!-- 新增编辑弹窗 -->
    <el-dialog :title="dialogType" :visible.sync="addFormShow" class="formDialog" :width="dialogWidth">
      <el-form :model="userInfo" :rules="rules" ref="userInfoForm" label-width="100px">
        <el-form-item label="真实姓名：" prop="realname">
          <el-input v-model="userInfo.realname"  maxlength="15" placeholder="请输入真实姓名(2-6个汉字）" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="手机号：">
          <!-- <el-input v-model="userInfo.mobile" placeholder="输入手机号可使用手机号登录" size="mini"></el-input> -->
          <el-input
            v-model="userInfo.mobile" 
            :disabled="isDetail"
            placeholder="输入手机号可使用手机号登录" 
            maxlength="11"
            size="mini"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="身份证：" prop="id_card">
          <el-input v-model="userInfo.id_card" placeholder="请输入身份证" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="userInfo.remark" placeholder="请输入备注" size="mini"  maxlength="50" show-word-limit type="textarea" style="width:250px"></el-input>
        </el-form-item>
        <el-form-item label="考试类别：" required>
          <!-- 考试类别 -->
            <el-checkbox-group v-model="appKeysType" @change="appKeysChange">
              <el-checkbox
              v-for="(item,index) in examOptions" :key="index" :label="item.key" :disabled="Boolean(item.user_is_jihuo)"
                >{{ item.value }}</el-checkbox
              >
            </el-checkbox-group>  
        </el-form-item>
        <el-form-item label="状态：">
          <el-radio-group v-model="userInfo.status" size="mini">
            <el-radio-button :label="1">启用</el-radio-button>
            <el-radio-button :label="0">禁用</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="!this.userInfo.uid || userInfo.is_can_relation_teacher==1" label="关联老师ID：" prop="teacher_ids">
          <el-select 
           v-model="teacher_ids" 
           size="small" 
           multiple
           collapse-tags
            @change="teacherChange" 
           clearable>
            <el-option
              v-for="item  in allTeacherList"
              :key="item.id"
              :label="item.realname"
              :value="item.id"
              >
            </el-option> 
          </el-select>

          <el-popover placement="right"  width="400" trigger="hover">
            <div v-html="AssociationExplanword" />  
            <i class="el-icon--right el-icon-question" slot="reference"></i>
          </el-popover> 


          <div v-if="teacherList.length>0">
            <el-tag
               v-for="(item, i) in teacherList"
               :key="item.id"
               effect="plain"
               style="margin-right: 10px;"
               closable
                @close="closeTag(item, i)"
              >
              {{ item.realname }}
            </el-tag>
          </div>
        </el-form-item>
 
        <el-form-item v-if="is_test == 1" label=" 限制登录设备次数：">
          <el-radio-group v-model="userInfo.limit_login_device_total" size="mini" @change="$forceUpdate()">
            <el-radio-button :label="1">限制</el-radio-button>
            <el-radio-button :label="0">不限制</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addUser('userInfoForm')" size="mini">确 定</el-button>
        <el-button @click="addFormShow = false" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="repeatShow" class="formDialog" :width="dialogWidth2">
       <div style="text-align: center;
                    font-size: 18px;
                    font-weight: bold;">{{repeatMessage}}，请确认是否新增</div>
       <div style="color: red;
                   text-align: center;
                   margin-top: 10px;"
        >（新增后姓名后面带上数字后缀，以做区别）</div>
       <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="determine(0)" size="mini">否</el-button>
        <el-button @click="determine(1)" size="mini">
           是 
          <!-- <p style="color:red">（姓名后面带上数字后缀以作区别）</p> -->
        </el-button>
      </div>
    </el-dialog>

    <!-- 修改密码弹窗 -->
    <el-dialog title="修改密码" :visible.sync="resetCodeShow" class="formDialog" :width="dialogWidth">
      <el-form :model="codeInfo" :rules="codeRules" ref="codeInfoForm" label-width="120px">
        <el-form-item label="输入新密码：" prop="new_password">
          <el-input v-model="codeInfo.new_password" placeholder="六位数以上" size="mini" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认新密码：" prop="new_password_confirmation">
          <el-input v-model="codeInfo.new_password_confirmation" placeholder="请确认密码" size="mini" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editCode('codeInfoForm')" size="mini">确 定</el-button>
        <el-button @click="resetCodeShow = false" size="mini">取 消</el-button>
      </div>
    </el-dialog>
 
    <!-- 删除 -->
    <el-dialog title="提示" :visible.sync="deleteCodeShow" class="formDialog" :width="dialogWidth">
      <div v-if="deleteCodeData.mobile" style="font-size:20px;">
        是否确认将手机号为<span style="color:red">{{deleteCodeData.mobile}}</span>的学员从启用列表删除？
      </div>
      <div v-else style="font-size:20px;">
        是否确认将学员ID为<span style="color:red">{{deleteCodeData.uid}}</span>的学员从启用列表删除？
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteConfirm()" size="mini">确 定</el-button>
        <el-button @click="deleteCodeShow = false" size="mini">取 消</el-button>
      </div>
    </el-dialog>
 
    <!-- 禁用 -->
    <el-dialog title="提示" :visible.sync="disableCodeShow" class="formDialog" :width="dialogWidth">
      <div v-if="disableCodeData.mobile" style="font-size:20px;">
        是否确认将手机号为<span style="color:red">{{disableCodeData.mobile}}</span>的学员从启用列表禁用？
      </div>
      <div v-else style="font-size:20px;">
        是否确认将学员ID为<span style="color:red">{{disableCodeData.uid}}</span>的学员从启用列表禁用？
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="disableConfirm()" size="mini">确 定</el-button>
        <el-button @click="disableCodeShow = false" size="mini">取 消</el-button>
      </div>
    </el-dialog>
 
    <!-- 转移 -->
    <el-dialog title="提示" :visible.sync="moveCodeShow" class="formDialog" :width="dialogWidth">
      <el-form :model="moveData" ref="moveData" label-width="220px"> 
        <el-form-item label="请输入指定的机构名称或ID：" prop="move_group_id" style="text-align:left;">
          <el-select
            v-model="moveData.move_group_id"
            filterable
            remote
            reserve-keyword
            clearable
            placeholder="模糊查询+下拉索引"
            :remote-method="moveRemote"
            :loading="moveLoading"
            style="width:400px;"
          >
            <el-option
              v-for="item in moveOptions"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select> 
        </el-form-item> 
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editMoveCode(moveData)" size="mini">确 定</el-button>
        <el-button @click="moveCodeShow = false" size="mini">取 消</el-button>
      </div>
    </el-dialog>


    <!-- 添加标签弹窗 -->
    <el-dialog title="编辑标签" :visible.sync="editLabelShow" class="formDialog" :width="dialogWidth">
      <div class="editLabelClass">
        <div class="p1">已添加标签</div>
        <div class="p2">
          <el-tag
            v-for="(tag,index) in userLabel"
            :key="index"
            closable
            @close="deleteLabel(tag)"
            >
            {{tag.name}}
          </el-tag>
        </div>
      </div>
      <div class="editLabelClass">
        <div class="p1">可添加标签</div>
        <div class="p2">
          <el-tag
            v-for="(tag,_index) in addLabel"
            type="success"
            :key="_index"
            @click="tagAddLabel(tag)"
            >
            {{tag.name}}
          </el-tag>
        </div>
      </div>
      <div class="editLabelClass">
        <div class="searchItem">
          <span>添加新建标签</span>
          <el-input v-model="addNewLabel" maxlength="10" clearable size="small" placeholder=请输入新标签名称 show-word-limit></el-input>
          <el-button type="success" @click="addNewLabelClick" size="mini">新增</el-button>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitLabel" size="mini">确 定</el-button>
        <el-button @click="editLabelShow = false" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 上传弹窗 -->
    <el-dialog title="" :visible.sync="outerVisible" :width="dialogWidth2">
        <div style="font-size: 18px; margin-bottom: 30px;font-weight: 600; color: #191B27;padding:0 10px;">
          批量导入学员 <span @click="skipImportRecord" style="font-size: 14px;font-weight:400;color: #00C793;cursor: pointer;margin-left: 20px;">查看导入记录</span>
        </div>
        <!-- <el-steps align-center>
          <el-step title="下载导入excel"  @click.native="exportExcel"> 
          </el-step>
          <el-step title="录入相关信息"></el-step>
          <el-step title="导入excel"></el-step>
        </el-steps> -->
        <div style="display:block;margin: 20px 90px;">
          <img class="pic" style="display:block;width:100%" src="../../assets/new/tj_a16.png" />
        </div>
        <div style="margin: 20px 90px; font-size: 14px;">
          <div style="margin-bottom: 20px;">一丶 请按照数据模板的格式准备要导入的数据  <span @click="exportExcel" style="font-size: 14px;font-weight:400;color: #846FFD;cursor: pointer;margin-left: 20px;">点击下载《学员导入模版》</span></div>
          <div style="margin-bottom:20px">二丶 选择需要导入的文件</div>
          <div class="outerBox">
            <el-input placeholder="请输入内容" v-model="fileName" class="input-with-select" >
              <el-upload
                style="display:inline-block;margin:0 15px;"
                action="/上传文件的接口"
                :on-change="onChange"
                :auto-upload="false"
                :show-file-list="false"
                slot="append"
                accept=".xls, .xlsx" >
                <el-button type="success" size="small">选取</el-button>
              </el-upload>
            </el-input>
          </div>
          <div style="font-size: 14px;
              font-weight: 500;
              color: #465069;
              padding: 10px 0 0 0;">
            导入说明
          </div>
          <div style="font-size: 14px; color: #465069; line-height: 180%;">
            1、姓名为必填项，至少两个中文汉字； </br>
            2、考试类别为必填项，在“考试类别”一栏可选择为学员开通指定的考试产品，目前有高职单招、成考，如填写了“成考”，学员登录APP后可直接进入到成考的学习页面； </br>
            3、手机号码填写后，可使用手机号码登录备考通APP，APP登录密码默认123456；支持学员在APP设置中心修改；
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="importCheck" >确 定</el-button>
            <!-- importFile -->
            <el-button @click="excelImport" >取 消</el-button>
        </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="checkVisible"
      class="formDialog"
      :width="dialogWidth"
    >
      <div style="text-align: center; padding: 20px 0">
        <div class="el-icon-success" ></div>
        <div v-if="checkData.repeat_group_realname" style="text-align: center; padding-bottom:20px;"> 
          有{{checkData.repeat_group_realname}}条数据的【姓名】在机构学员管理列表已存在，请确认是否导入
        </div>
        <div v-if="checkData.repeat_excel_realname" style="text-align: center; padding-bottom:20px;">
          本次导入的列表中，有{{checkData.repeat_excel_realname}}条数据的【姓名】存在重复，请确认是否导入
        </div>
        <div>
          <el-button type="primary" @click="importFile(0)" size="mini" style="height:60px;vertical-align: middle;font-size:14px;">不导入，过滤同名数据</el-button>
          <el-button type="primary" @click="importFile(1)" size="mini" style="height:60px;vertical-align: middle;font-size:14px;">
            导入
            <div style="color:red;margin-top:10px;">姓名后面带上数字后缀以作区别）</div>
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="popVisible"
      class="formDialog"
      :width="dialogWidth"
    >
      <div style="text-align: center; padding: 20px 0">
        <div class="el-icon-success" ></div>
        <div style="text-align: center;padding-bottom:20px;">
          数据导入完成
        </div>
        <div style="text-align: center;">
          总数{{popData.total}}条，导入成功{{popData.succ}}条，导入失败{{popData.error}}条
          <el-button v-if="popData.error>0" type="primary" @click="downloadFailed()" size="mini" style="margin-left:10px;">下载失败数据</el-button>
        </div>
        <div style="text-align: center;padding-top:20px;">
          <el-button type="text" @click="seeDetails()">查看详情</el-button>
        </div>
 
      </div>
    </el-dialog>
 
    <el-dialog
      title=""
      :visible.sync="excelVisible"
      class="formDialog"
     :width="dialogWidth"
    >
      <div style="text-align: center; padding: 20px 0">
        导出任务已提交，请前往
        <span style="color: #409eff; cursor: pointer" @click="excelClick"
          >数据导出中心</span
        >
        查看进度
      </div>
    </el-dialog>

    <SelectBuyGoods :buyGoodsShow.sync="selectBuyGoodsShow" @updateTable="queryTable" :dialogWidth="dialogWidth2" :goodsNeedId="goodsNeedId" :goodsName="goodsName" :selectableShow="true"  v-if="selectBuyGoodsShow" />
  
    
    <el-dialog
      title=""
      :visible.sync="batch1Visible"
      class="formDialog"
      :width="dialogWidth"
    >
      <div style="text-align: center; padding: 20px 0">
        <!-- 关联老师 -->
        <div v-if="allStatus">
          已选择“所有学员”（共计 <span style="color: red;">{{ queryInfo.total }}</span> 个）关联老师 
        </div>
        <div v-else>  
          <div>已选择 <span style="color: red;">{{this.selectedList.length}}</span> 个学员</div>
          <div style="text-align: center; padding-top: 10px">请选择需要关联的老师</div>
        </div>
        <div style="text-align: center; padding: 10px 0">
          <el-select 
           v-model="batch1TeacherIds" 
           size="small" 
           multiple
           collapse-tags
           clearable>
            <el-option
                  v-for="item  in allTeacherList"
                  :key="item.id"
                  :label="item.realname"
                  :value="item.id"
                >
            </el-option> 
          </el-select>
        </div> 
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="batch1Save" >确 定</el-button> 
            <el-button @click="batch1Visible=false" >取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="batch2Visible"
      class="formDialog"
      :width="dialogWidth"
    >
      <div style="text-align: center; padding: 20px 0">
        <!-- 取消关联 -->
        <div v-if="allStatus">
          已选择“所有学员”（共计<span style="color: red;">{{ queryInfo.total }}</span>个）取消关联老师 
        </div>
        <div v-else> 
          <div>已选择 <span style="color: red;">{{ selectedList.length}}</span> 个学员</div>
          <div style="text-align: center; padding-top: 10px">请选择需要取消关联的老师</div>
        </div> 
        <div style="text-align: center; padding: 10px 0">
          <el-select 
           v-model="batch2TeacherIds" 
           size="small" 
           multiple
           collapse-tags
           clearable>
            <el-option
                  v-for="item  in allTeacherList"
                  :key="item.id"
                  :label="item.realname"
                  :value="item.id"
                >
            </el-option> 
          </el-select>
        </div> 
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="batch2Save" >确 定</el-button> 
            <el-button @click="batch2Visible=false" >取 消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="batch4Visible"
      class="formDialog"
      :width="dialogWidth"
    >
        <div v-if="allStatus" style="color:#000;margin-bottom: 15px;text-align: center;">
          <div>已选择“所有学员”（共计<span style="color: red;">{{queryInfo.total}}</span>个）</div>
          <div style="text-align: center; padding-top: 10px">请选择需要添加的标签</div>
        </div>
        <div v-else style="color:#000;margin-bottom: 15px;text-align: center;"> 
          <div>已选择 <span style="color: red;">{{selectedList.length}}</span> 个学员</div>
          <div style="text-align: center; padding-top: 10px">请选择需要添加的标签</div>
        </div> 
        <div class="editLabelClass">
          <div class="p1">已添加标签</div>
          <div class="p2">
            <el-tag
              v-for="(tag,index) in userLabel4"
              :key="index"
              closable
              @close="deleteLabel4(tag)"
              >
              {{tag.name}}
            </el-tag>
          </div>
        </div>
        <div class="editLabelClass">
          <div class="p1">可添加标签</div>
          <div class="p2">
            <el-tag
              v-for="(tag,_index) in addLabel4"
              type="success"
              :key="_index"
              @click="tagAddLabel4(tag)"
              >
              {{tag.name}}
            </el-tag>
          </div>
        </div>
        <div class="editLabelClass">
          <div class="searchItem">
            <span>添加新建标签</span>
            <el-input v-model="addNewLabel4" maxlength="10" clearable size="small" placeholder=请输入新标签名称 show-word-limit></el-input>
            <el-button type="success" @click="addNewLabelClick4" size="mini">新增</el-button>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="batch4Save" size="mini">确 定</el-button>
          <el-button @click="batch4Visible = false" size="mini">取 消</el-button>
        </div> 
    </el-dialog>

    <el-dialog 
      title=""
      :visible.sync="batch3Visible"
      class="formDialog"
      :width="dialogWidth">
      <div style="text-align: center; padding: 20px 0"> 
        <div>
          确认取消 <span style="color: red;">{{this.selectedList.length}}</span> 个学员 <br/>
           关联以下老师？
        </div>
        <div style="text-align: center; padding: 20px 0">
          <el-tag v-for="item in batch2TeacherList" :key="item.id" style="margin-right: 10px;">{{ item.realname }}：ID{{ item.id }}</el-tag>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="batch3Save" >确 定</el-button> 
            <el-button @click="batch3Visible=false" >取 消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog 
      title=""
      :visible.sync="batchOperationVisible"
      class="formDialog"
      :width="dialogWidth">
        <div v-if="allStatus"> 
          <h3 style="text-align: center;margin-bottom: 10px;">
            已选择“所有学员”（共计<span style="color: red;">{{queryInfo.total}}</span>个） 
          </h3>  
        </div>
        <div v-else>
          <h3 style="text-align: center;margin-bottom: 10px;">
            已选择 <span style="color: red;">{{selectedList.length}}</span> 个学员
          </h3>
          <div style="text-align: center;">
            请选择需要执行批量操作的项目
          </div>
        </div> 
        <div style="text-align: center; padding: 10px 0">
          <el-select 
           v-model="batchOperationId" 
           size="small"
           clearable>
            <el-option
                  v-for="item  in batchOperationList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
            </el-option> 
          </el-select>
        </div> 
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="batchOperationSave" >确 定</el-button> 
            <el-button @click="batchOperationVisible=false" >取 消</el-button>
        </div>
    </el-dialog> 

    <el-dialog 
      title=""
      :visible.sync="batchOperation2Visible"
      class="formDialog"
      :width="dialogWidth"> 
        <div style="text-align: center; padding: 10px 0"> 
          <div v-if="batchSuccess>0">
            已成功
            <span v-if="batchOperationId==1">禁用</span>   
            <span v-if="batchOperationId==3">删除</span>   
            <span style="color: red;">{{batchSuccess}}</span>
            个学员
          </div>
          <div v-else>   
            <div v-if="batchStudentNum>batchCountNum&&batchUnableNum>0">
              已产生订单的<span style="color: red;">{{batchCountNum}}</span>个学员无法删除确认要删除剩下的<span style="color: red;">{{batchUnableNum}}</span>个学员？
            </div>
            <div v-else-if="batchCountNum!=0&&batchCountNum==batchStudentNum">
              已产生订单的<span style="color: red;">{{batchCountNum}}</span>个学员无法 
              <span v-if="batch2Type==3||batch2Type==4">删除</span>   
            </div> 
          </div>
        </div> 
        <div slot="footer" class="dialog-footer"> 
          <div v-if="batchSuccess>0">
            <el-button type="primary" @click="batchOperation2Visible=false" >确 定</el-button>  
          </div>
          <div v-else> 
            <el-button type="primary" @click="batchOperation2Save" >确 定</el-button> 
            <el-button @click="batchOperation2Visible=false" >取 消</el-button>
          </div>
        </div>
    </el-dialog> 

  </div>
</template>

<script>
import goodsApi from "@/api/goods.js";
import studentApi from '@/api/student.js' 
import { clearObj,deepClone,copyToClip } from '@/utils/index.js' 
// import TableComponents from '@/components/TableComponents.vue';
import SelectBuyGoods from '@/components/SelectBuyGoods.vue';
import commonApi from "@/api/common";
import qee from "qf-export-excel" 
import MyButton from "@/components/MyButton.vue";
import { number } from "echarts";
export default {
  name:'studentManage',
  components:{
    // TableComponents,
    SelectBuyGoods, 
    MyButton,
  },
  data(){
    var confirmPasswordVerify = (_, value, callback) => {
      if (!value) {
        return callback(new Error("确认密码不能为空"));
      } else if (value != this.codeInfo.new_password) {
        return callback(new Error("两次密码输入需一致"));
      } else {
        callback();
      }
    };
    return{
      options:[],
      options1:[],
      options2:[
        //  {value: 'adultscollege_1', label: '已激活成考'},
        //  {value: 'senioriup_1', label: '已激活高职单招'},
        //  {value: 'adultscollege_0', label: '未激活成考'},
        //  {value: 'senioriup_0', label: '未激活高职单招'},  
      ],
      options3:[],
      loading:false,
      queryInfo:{
        limit:10,
        page:1,
        total:0,
        status:1,//状态 -1全部 1启用 0禁用 
        open_status:"",//是否激活 -1全部 1启用 0禁用 
        keyword:"",//用户信息 支持账号真实姓名手机号
        start_time:"",//创建开始时间
        end_time:"",//创建结束时间
        tag_id:"",//标签id
        id_card:"",//身份证号
        tob_good_id:"", //已开通商品
        remark:"", //备注
        // createTime:[]
      },
      columns:[//列数据
        {label:"学员ID",prop:"uid",isSelfShow:true},
        {label:'学员登录账号',prop:'username'},
        {label:'真实姓名',prop:'realname'},
        {label:'手机号',prop:'mobile'},
        {label:'添加方式',prop:'add_type', isMyself: true},
        {label:'身份证',prop:'id_card'},
        {label:'开通考试类别',prop:'app_names'},
        {label:'已开通商品',prop:'courses', isMyself: true},
        {label:'学员激活状态',prop:'active_status_txt',width:140},
        {label:'激活时间',prop:'active_at'}, 
        {label:'学员标签',prop:'tags',width:200},
        {label:'创建人',prop:'create_user'},
        {label:'创建时间',prop:'created_at'},
        {label:'更新人',prop:'update_user'},
        {label:'更新时间',prop:'updated_at'},
        {label:'备注',prop:'remark'},
        {label:'操作',prop:'operation',width:180}
      ],
      tableList:[],
      all_self_show_field:[],
      // 新增编辑表单数据
      addFormShow:false,
      userInfo:{
        mobile:"",
        realname:'',
        id_card:"",
        remark:"",
        status:1,
        uid:'', 
      },
      rules:{              
        realname: [{ required: true, message: '请输入真实姓名', trigger: 'blur' },
        // {
        //     validator: function(rule, value, callback) {
        //       if (/^[\u4e00-\u9fa5]+$/.test(value) == false) {
        //         callback(new Error("请输入2-6个汉字"));
        //       } else {
        //         //校验通过
        //         callback();
        //       }
        //     },
        //     trigger: "change"
        //   },
      ],           
      },

      // 重置密码弹窗
      resetCodeShow:false,
      codeInfo:{
        new_password:'',
        new_password_confirmation:'',
      },
      codeRules:{
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 15, message: '密码必须使用6-15位字符', trigger: 'change' }
        ],                
        new_password_confirmation: [
          { required: true, validator: confirmPasswordVerify, trigger: 'blur' },
        ],                
      },

      editLabelShow:false,
      // 已添加标签
      userLabel:[],
      userAddLabel:[],
      userDeleteLabel:[],
      // 可添加标签
      addLabel:[],
      addNewLabel:"",
      chioceUid:'',

      // 学员开课字段
      selectBuyGoodsShow:false,

      // 读取文件
      fileData:"",

      // good
      goodsNeedId:"",
      goodsName:"",
      outerVisible:false,
      fileName:"",
      excelList:[],
      timeFrame:[],
      examOptions:[
      // 成考：adultscollege
      // 高职单招：senioriup
        // {value: 'adultscollege', label: '成考',actState:false},
        // {value: 'senioriup', label: '高职单招',actState:false},
      ],
      examOptionsArr:[],
      adultscollege:true,
      senioriup:true,
      detailShow:false,
      app_keys:[], 
      appKeysType:[],
      antiShaking:true,
      
      checkAll: [],
      popoverOptions: [],
      popoverChecked: [],
      revealVisible: false,
      isIndeterminate: true, 
      allMoneyTip: "学员登录APP进入首页后，会有一个激活弹窗，学员点击激活即可成功激活考试商品。后台才会正式扣除费用。", // 学员激活状态提示
      active_status_txt: '',
      tableBox: null,
      // tableWrapper: null,
      // tableHeader: null,
      tableDom: null,
      topScrollBox: null,
      topScrollWidth: 0, 
      group_id:'',//APP邀请码 
      
      firstSrc:'',
      firstWidth:'100%', 
      firstHeight:'800px', 
      statusOptions:[],  
      excelVisible: false,
      createUserOptions: [],
      create_user: [],
      role: "",
      deleteCodeShow:false,
      deleteCodeData:{},
      disableCodeShow:false,
      disableCodeData:{}, 
      popVisible: false,
      checkVisible: false, 
      popData:{},
      checkData:{},
      record_id:"",
      repeatShow:false,
      repeatMessage:"",
      postData:{},
      oldMobile:'',
      moveData:{},
      unbindData:{},
      moveCodeShow:false,
      moveLoading:false,
      moveOptions:[],
      lockings:true,
      is_update_student_teacher: 0,
      me_id: 0,
      me_realname:"", 
      allTeacherList:[],
      teacherList:[],
      teacher_ids:[],
      selectedList:[],
      allSelectedStatus: false,
      batch1Visible: false,
      batch2Visible: false, 
      batch1TeacherIds:[],
      batch2TeacherIds:[], 
      batch3Visible: false,
      batch2TeacherList:[],
      allStatus: false,
      allStatusText:"选择所有页",
      lockStatus:true, 
      batchOperationVisible: false,
      batchOperationId:"",
      batchOperationList:[
        {value: 1, label: '批量禁用'},
        {value: 3, label: '批量删除'},
      ],
      batchOperationTitle:"",
      lockType: true,
      batchOperation2Visible: false,
      batch2Data:{},
      batch2Type:"",
      batchCountNum: 0, //剩下的
      batchUnableNum: 0, //无法删除
      batchStudentNum: 0,
      batchSuccess: 0,  
      batch4Visible: false,
       // 已添加标签
      userLabel4: [],
      userAddLabel4: [],
      userDeleteLabel4: [],
      // 可添加标签
      addLabel4: [],
      addNewLabel4: '',
      chioceUid4: '',
      show_student_archive: '',
      isDetail: false, 
      AssociationExplanword: '', 
      operationWidth: '280', 
      add_type_list:[],
      dialogWidth: '500px',
      dialogWidth2: '900px',
      is_test: 0,
      show_student_active_status: 0  
    }
  },
  computed:{
    dialogType(){
      //  'this.userInfo.id',this.userInfo.uid);
      return this.userInfo.uid?'编辑':'新增'
    },
    isSalespersonr(){
      //  this.$store.state.user.userInfo.role,this.$store.state.user.userInfo.role == 'salespersonr');
      return this.$store.state.user.userInfo.role == 'salespersonr'
    },
    allSelfShowFieldMap() {
      return new Map(this.all_self_show_field.map(item => [item.field, item.is_selected]))
    },
    statusMap() {
      return new Map(this.statusOptions.map((item) => [item.id, item.name]));
    }, 
    addTypeMap() {
      return new Map(this.addTypeOptions.map((item) => [item.id, item.name]));
    }, 
  },  
  watch:{
    topScrollWidth: {
      // 两个滚动条同时滚动
      handler(newVal, oldVal) {
        console.log("33333",newVal)
        // 监听滚动条
        this.$nextTick(() => {
          this.tableDom.addEventListener("scroll", this.syncTopScroll);
          const topScroll = this.$refs.topScroll;
          topScroll.addEventListener("scroll", this.syncTabScroll); 
        });
      },
      deep: true
    },
    selectBuyGoodsShow:{
      handler(_newVal){
        //  _newVal);
      }
    },  
    addFormShow:{
      handler(_newVal){
        if(!_newVal){
          Object.keys(this.userInfo).forEach(key =>{
            if(typeof this.userInfo[key] == 'string'){
              this.userInfo[key] = ''
            }else if((typeof this.userInfo[key] == 'number')){
              this.userInfo[key] = 1
            }
          });
          this.userInfo.uid = ''
        }
      }
    },
    resetCodeShow:{
      handler(_newVal){
        if(!_newVal){
          clearObj(this.codeInfo)
          this.$refs['codeInfoForm'].resetFields();
        }
      }
    },
    editLabelShow:{
      handler(_newVal){
        if(!_newVal){
          this.addNewLabel = ''
        }
      }
    },
    timeFrame:{
      handler(_newVal){
        if(!_newVal){
          this.timeFrame = [];
        }
      },
      deep:true
    },
 
  },
  created(){
    this.show_student_archive = localStorage.getItem("show_student_archive");
    this.show_student_active_status = localStorage.getItem("show_student_active_status"); 
    // if(this.show_student_active_status == 1){
    //   this.columns.forEach((item, index)=>{
    //     if(item.prop == 'active_status_txt'){
    //       this.columns.splice(index, 1) 
    //     }
    //   })
    // }
    console.log("this.show_student_active_status", this.show_student_active_status)

    if (process.env.NODE_ENV === 'development') {
      this.firstSrc = 'http://testLavaMobile.qbting.com/testtask/#/web?key=beikaotonglogoyaoqingma&apptype=beikaotong'
    } else {
      this.firstSrc = 'http://qmb.meite.com/task/#/web?key=beikaotonglogoyaoqingma&apptype=beikaotong'
    }
    
    if(this.$route.query&&this.$route.query.mobile){
      this.queryInfo.keyword = this.$route.query.mobile
    }
    if(this.$route.query&&this.$route.query.status){
      this.queryInfo.status = Number(this.$route.query.status) 
    } 

    if(this.$route.query&&this.$route.query.name){
      this.queryInfo.keyword = this.$route.query.name
    }
    if(this.$route.query&&this.$route.query.add_type){
      this.queryInfo.add_type = 3
    }
    if(this.$route.query&&this.$route.query.app_type){ 
      this.app_keys=[]
      this.app_keys.push(this.$route.query.app_type) 
    }  
    if(this.$route.query&&this.$route.query.realname){ 
      this.create_user=[]
      var keywords = this.$route.query.realname
      this.create_user.push(keywords) 
      this.getTobSearchCreateUser(keywords)
    }  
    this.getDic()
    this.getMe()
    this.tobGoodList()
    this.getTobOpenExams()
    this.queryTable()

    this.innerWidth()
    console.log("innerWidth", window.innerWidth) 
  },   
  mounted() {
    // 添加监听滚动条事件
    window.addEventListener("resize", this.setScrollWidth); 
  },
  destroyed() {
    // 移除（跳转页面后移除）
    window.removeEventListener("scroll", this.syncTopScroll);
    window.removeEventListener("scroll", this.syncTabScroll);
    window.removeEventListener("resize", this.setScrollWidth);
  },
  methods:{
    innerWidth(){
      let innerWidth = window.innerWidth
      if(innerWidth <= 600){ 
        this.operationWidth = 80  
        this.dialogWidth = '96%' 
        this.dialogWidth2 = '96%' 
      } else {
        this.operationWidth = 280 
        this.dialogWidth = '500px' 
        this.dialogWidth2 = '900px' 
      }
    }, 
    getDic() {
      commonApi.getInfoToName({ name: "copysettings" }).then((res) => { 
        if (res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            if (item.key == "AssociationExplanword") {
              console.log("AssociationExplanword", item.value)
              this.AssociationExplanword = item.value;
            }
          });
        }
      });
    }, 
    studentDetails(e){
      console.log("uid", e.uid) 
      const routeUrl = this.$router.resolve({
        path: "/studentDetails",
        query: { uid: e.uid },
      })
      window.open( routeUrl.href, "_blank")  
    },
    tableClear(){ 
      this.$refs.tableRef.clearSelection()
      this.allStatus = false
      this.allSelectedStatus = false 
    },
    studentProfile(){
      // 学员档案
      this.$router.push({
        path: "/studentProfile",
        // query: { order_no: e.order_no, order_type: e.order_type },
      }); 

    },
    deleteLabel4(tag){
      this.userLabel4.forEach((item,index)=>{
        if(item.id == tag.id){
          this.userLabel4.splice(index,1)
        }
      })
      let flag = 0
      this.userAddLabel4.forEach((item,index)=>{
        if(item.id == tag.id){
          this.userAddLabel4.splice(index,1)
          flag = 1
        }
      })
      let allFlag = 0
      allFlag = this.addLabel4.forEach((item,index)=>{ 
          return item.id == tag.id
        })
      if(!allFlag){
        this.addLabel4.push(tag)
      }
      if(!flag){
        const _flag = this.userLabel4.some((item,index)=>{
          return item.id == tag.id
        })
        if(!_flag){
          this.userDeleteLabel4.push(tag)
        }
      }
    },
    tagAddLabel4(tag){
      this.addLabel4.forEach((item,index)=>{ 
          if(item.id == tag.id){ 
            this.addLabel4.splice(index,1)
          }
        })
      if(!this.userLabel4.length){
        this.userLabel4.push(tag)
        this.userAddLabel4.push(tag)
        return
      }
      const _flag = this.userLabel4.some((item,index)=>{
        return item.id == tag.id
      })
      if(!_flag){ 
        this.userLabel4.push(tag)
        this.userAddLabel4.push(tag)
      }
    },
    async addNewLabelClick4(){
      const res = await studentApi.tobTagsAdd({name:this.addNewLabel4})
      if(res.code == 200){
        this.$message.success("新增标签成功")
        this.addNewLabel4 = ''
        studentApi.studentsTags({ type:2 }).then(res => { 
          if (res.code == 200) { 
            this.addLabel4 = res.data.list;
            this.userLabel4.forEach((item,index)=>{
              this.addLabel4.forEach((item1,index1)=>{
                if(item.id == item1.id){
                  this.addLabel4.splice(index1,1)
                }
              })
            }) 
            console.log("batch4Visible", this.batch4Visible, this.addLabel4)
          }
        })  
      }else{
        this.$message.error(res.message)
      }
    },
    batch4Save(){
      var student_ids = []
      if(this.selectedList&&this.selectedList.length > 0&&!this.allStatus){
        for (let i = 0; i < this.selectedList.length; i++) {
          student_ids.push(this.selectedList[i].uid)
        }
      }  
      var tag_ids = []
      if(this.userLabel4.length==0){
        this.$message.error("请选择添加标签！")
      }
      if(this.userLabel4&&this.userLabel4.length > 0){
        for (let i = 0; i < this.userLabel4.length; i++) {
          tag_ids.push(this.userLabel4[i].id)
        }
      }  
      
      console.log("batch4Save", this.selectedList, this.userLabel4, tag_ids,student_ids)
       
      if(!this.allStatus){ 
        this.studentsBatch(5, student_ids.toString(), tag_ids.toString())
      }else if(this.allStatus){
        this.studentsBatch(6, "", tag_ids.toString())
      }
    },
    getHasOrderStudentCount(type,student_uids,student_num){
        commonApi.getHasOrderStudentCount({student_uids: student_uids}).then(res => {  
          
          if (res.code == 200) {   
            this.batchCountNum = res.data.count
            if(student_num){
              this.batchStudentNum = Number(student_num)
            } else { 
              this.batchStudentNum = parseInt(this.queryInfo.total) 
            } 

            if(this.batchStudentNum>0&&res.data.count>0){  
              this.batchUnableNum = this.batchStudentNum - this.batchCountNum
            }   
            this.batch2Type = type   
            if(this.allStatus&&this.batchCountNum==0){
              if(this.batchOperationId == 1){
                this.studentsBatch(2,'') 
              }else if(this.batchOperationId == 3){
                this.studentsBatch(4,'') 
              } 
            }else if(!this.allStatus&&this.batchCountNum==0){
              if(this.batchOperationId == 1 ){
                this.studentsBatch(1,student_uids)
              }else if(this.batchOperationId == 3){
                this.studentsBatch(3,student_uids) 
              }
            }else{  
              this.batchOperation2Visible=true  
            }  
          }
        })
    },
    batchOperation2Save(){
      var student_ids = []
      if(this.selectedList&&this.selectedList.length > 0&&!this.allStatus){
        for (let i = 0; i < this.selectedList.length; i++) {
          student_ids.push(this.selectedList[i].uid)
        }
      }  
      if(this.batchOperationId == 1 && !this.allStatus){
        this.studentsBatch(1,student_ids.toString())
      }else if(this.batchOperationId == 3 && !this.allStatus){
        this.studentsBatch(3,student_ids.toString()) 
      }else if(this.batchOperationId == 1 && this.allStatus){
        this.studentsBatch(2,'') 
      }else if(this.batchOperationId == 3 && this.allStatus){
        this.studentsBatch(4,'') 
      } 
    }, 
    studentsBatch(type,student_uids='',tag_ids=''){ 
      if(this.lockType){
        this.lockType = false 
        var postData = deepClone(this.queryInfo) 

        if(this.queryInfo.tob_good_id){
          postData.is_good_filter = 1
        }else{
          postData.is_good_filter = 0
        }
        if (this.app_keys.length > 0) {
          postData.app_keys= this.app_keys.toString()
        }
        if (this.create_user.length > 0) {
          postData.create_user = this.create_user.join(",");
        } 
        postData.type = type
        postData.student_uids = student_uids
        if(type==5||type==6){
          postData.tag_ids = tag_ids
        }   
        commonApi.studentsBatch(postData).then(res => {  
          this.lockType = true
          if (res.code == 200) {  
            this.batchSuccess = res.data.success  
            if(this.batchCountNum==0){
              this.batchOperationVisible = false 
              this.batch4Visible = false   

              this.$message({
                message: res.message,
                type: 'success'
              })
              
              // this.batchOperation2Visible = true
            }else{ 
              this.batchOperationVisible = false   
              this.batchOperation2Visible = false  
              
              this.batch4Visible = false   
            }  

            this.allStatus = false 
            this.$refs.tableRef.clearSelection()  
            this.queryTable()
          }else{ 
            this.$message({
              message: '请先选择学员！',
              type: 'warning',
            });
          }
        })
      }     
    },
    batchOperationSave(){ 
      this.batchSuccess = 0
      if(this.batchOperationId == 1 && !this.allStatus){ 
        this.batchOperationTitle = "确认要禁用"+this.selectedList.length+"个学员？"
      }else if(this.batchOperationId == 3 && !this.allStatus){ 
        this.batchOperationTitle = "确认要删除"+this.selectedList.length+"个学员？"
      }else if(this.batchOperationId == 1 && this.allStatus){
        this.batchOperationTitle = "确认要禁用所有学员？"
      }else if(this.batchOperationId == 3 && this.allStatus){
        this.batchOperationTitle = "确认要删除所有学员？"
      }
      this.$confirm( this.batchOperationTitle , '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => { 
         if(this.selectedList&&this.selectedList.length > 0&&!this.allStatus){
          var student_ids = []
          for (let i = 0; i < this.selectedList.length; i++) {
            student_ids.push(this.selectedList[i].uid)
          }
         }  
 
         if(this.batchOperationId == 1 && !this.allStatus){ 
          this.studentsBatch(1,student_ids.toString())
         }else if(this.batchOperationId == 3 && !this.allStatus){
          this.getHasOrderStudentCount(3,student_ids.toString(),this.selectedList.length) 
         }else if(this.batchOperationId == 1 && this.allStatus){ 
          this.studentsBatch(2,'') 
         }else if(this.batchOperationId == 3 && this.allStatus){
          this.getHasOrderStudentCount(4, '', '')  
         }


        //  if(this.batchOperationId == 1 && !this.allStatus){
        //   this.studentsBatch(1,student_ids.toString())
        //  }else if(this.batchOperationId == 3 && !this.allStatus){
        //   this.studentsBatch(3,student_ids.toString()) 
        //  }else if(this.batchOperationId == 1 && this.allStatus){
        //   this.studentsBatch(2,'') 
        //  }else if(this.batchOperationId == 3 && this.allStatus){
        //   this.studentsBatch(4,'') 
        //  }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      }) 
    },
    batchOperation(){
      if(this.selectedList.length == 0&&!this.allStatus){
        this.$message({
          message: '请先选择学员！',
          type: 'warning',
        });
        return
      } 
        this.batchOperationVisible=true
        this.batchOperationId = "" 
    },
    selectable(row,index){
      if(this.allStatus){
        return false;
      }else{ 
        if(row.is_can_relation_teacher==1){
          return true;
        }else{
          return false;
        }
      } 
    },
    closeTag(tag, index) {   
        for (let i = 0; i < this.teacherList.length; i++) { 
          if(this.teacherList[i].id==tag.id){
              this.teacherList.splice(i, 1); 
          }
        } 
        this.teacher_ids = []
        for (let i = 0; i < this.teacherList.length; i++) { 
          this.teacher_ids.push(this.teacherList[i].id);
        }
    },
    teacherChange(e){
      console.log("teacherChange",e)
      if(e){ 
        this.teacherList = [] 
        for (let i = 0; i < this.allTeacherList.length; i++) {
          for (let j = 0; j < e.length; j++) {
            if(e[j]==this.allTeacherList[i].id){ 
              this.teacherList.push(this.allTeacherList[i])
            }
          }
        }

        this.unique(this.teacherList)
      }
    },
    // 去重操作
    unique(arr) {
      for (var i = 0; i < arr.length; i++) {
        for (var j = 0; j < arr.length; j++) {
          if (arr[i].id == arr[j].id && i != j) {
            // 将后面重复的数删掉
            arr.splice(j, 1)
          }
        }
      }
      return arr
    },
    allStatusChange(e){
      this.$refs.tableRef.clearSelection()
      this.$nextTick(() => {
        this.allStatus = e
        this.allSelectedStatus = false
        this.selectedList = []
        if(e){  
          this.allStatusText = '已选所有页'
        } else {
          this.allStatusText = '选择所有页'
        }
      })
      console.log("allStatus",e,this.allStatus)
      this.$forceUpdate()
    },
    batch3Save(){ 
      var student_ids = []
      if(this.selectedList&&this.selectedList.length > 0){
        for (let i = 0; i < this.selectedList.length; i++) {
          student_ids.push(this.selectedList[i].id)
        }
      }
      this.batchTeacher(2,this.batch2TeacherIds.toString(),student_ids.toString())       
    },
    batch2Save(){
      if(this.batch2TeacherIds&&this.batch2TeacherIds.length == 0){
        this.$message({
          message: '请先选择取消关联的老师！',
          type: 'warning',
        });
        return
      }
      if(this.allStatus){
        this.batchTeacher(4,this.batch2TeacherIds.toString(),'')
      }else{ 
        if(this.allTeacherList.length > 0&&this.batch2TeacherIds.length > 0){
          this.batch2TeacherList = []
          for (let i = 0; i < this.allTeacherList.length; i++) {
            for (let j = 0; j < this.batch2TeacherIds.length; j++) {
              if( this.allTeacherList[i].id ==  this.batch2TeacherIds[j]){
                this.batch2TeacherList.push(this.allTeacherList[i])
              }
            }
          }
        }
        this.batch3Visible=true
        this.batch2Visible=false
      }
    },
    batch1Save(){
      if(this.batch1TeacherIds&&this.batch1TeacherIds.length == 0){
        this.$message({
          message: '请先选择关联老师！',
          type: 'warning',
        });
        return
      }
      if(this.allStatus){
        this.batchTeacher(3,this.batch1TeacherIds.toString(),'')
      }else{ 
        var student_ids = []
        if(this.selectedList&&this.selectedList.length > 0){
          for (let i = 0; i < this.selectedList.length; i++) {
            student_ids.push(this.selectedList[i].id)
          }
        }
        this.batchTeacher(1,this.batch1TeacherIds.toString(),student_ids.toString())
      }

    },
    associateTeacher(i){
      console.log('associateTeacher',i,!this.allStatus)
      if(this.selectedList.length == 0&&!this.allStatus){
        this.$message({
          message: '请先选择学员！',
          type: 'warning',
        });
        return
      }
      if(i==1){
        this.batch1Visible=true
        this.batch1TeacherIds = []
      }else if(i==2){
        this.batch2Visible=true
        this.batch2TeacherIds = []
      }else if(i==3){  
        if(this.selectedList.length>0||this.allStatus){ 
          studentApi.studentsTags({ type:2 }).then(res => { 
            if (res.code == 200) {
              this.batch4Visible = true 
              this.addLabel4 = res.data.list;
              this.userLabel4 = [];
              console.log("batch4Visible", this.batch4Visible, this.addLabel4)
            }
          }) 
        }else{
          this.$message.error("请先选择学员！");
        } 
 
      }
    },
    batchTeacher(type,teacher_ids,student_ids){
      if(this.lockStatus){
        this.lockStatus = false
        studentApi.batchTeacher({
          type: type,
          teacher_ids:teacher_ids,
          student_ids:student_ids
        }).then(res => {  
          this.lockStatus = true
          if (res.code == 200) {
            this.$refs.tableRef.clearSelection()
            this.batch1Visible = false
            this.batch2Visible = false
            this.batch3Visible = false
            this.allStatus = false
            this.allStatusText = '选择所有学员'
            this.allSelectedStatus = false

            this.queryTable()
            const h = this.$createElement;

            if(type==1){
              this.$message({
                message: h('p', null, [
                  h('span', null, '已成功关联 '),
                  h('i', { style: 'color: red;margin: 0 10px;' }, res.data.success),
                  h('span', null, '个学员 ')
                ]),
                type: 'success'
              });
            }else if(type==2){
              this.$message({
                message: h('p', null, [
                  h('span', null, '已成功取消关联 '),
                  h('i', { style: 'color: red;margin: 0 10px;' }, res.data.success),
                  h('span', null, '个学员 ')
                ]),
                type: 'success'
              });
            }else{
              this.$message({
                message: res.message,
                type: "success",
              });
            }



          }
        })
      }     
    },
    handleSelectionChange(e) {
      var selectedNum = []
      this.tableList.forEach(item => {
        if(item.is_can_relation_teacher==1){
          selectedNum.push(item) 
        } 
      })

      console.log("selectedList",e)

      this.selectedList = e
      this.allStatus = false
      this.allStatusText = '选择所有学员'
      if (this.selectedList.length == selectedNum.length) {
        this.allSelectedStatus = true
      } else {
        this.allSelectedStatus = false
      }
    },
    allSelected(e) {
      this.selectedList = []
      if (e) {
        this.allStatus = false
        this.allStatusText = '选择所有学员' 
        this.allSelectedStatus = true
        // this.selectedList = this.tableList
        this.$refs.tableRef.clearSelection()
        this.tableList.forEach(item => {
          if(item.is_can_relation_teacher==1){
            this.selectedList.push(item) 
            this.$refs.tableRef.toggleRowSelection(item)
          }
        })
      } else {
        this.allStatus = false
        this.allStatusText = '选择所有学员'
        this.allSelectedStatus = false
        this.$refs.tableRef.clearSelection()
      }
    },
    async getAllTeacherList(){  
      const res = await studentApi.getAllTeacherList()
      if(res.code == 200){
        console.log("getAllTeacherList", res.data)
        this.allTeacherList = res.data.list 
      }
    },
    moveRemote(e) {
      if (e) {
        this.moveLoading = true;
        studentApi.searchGroupName({ keywords: e }).then(res => {
          this.moveLoading = false;
          if (res.code == 200) {
            console.log("remoteMethod", res.data.list);

            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].title =  res.data.list[i].name +'（ID'+ res.data.list[i].id +'）' 
            }  
            this.moveOptions = res.data.list; 
          }
        });
      }
    },
    determine(e){ 
      if(e){ 
        var query = deepClone(this.postData);
        query.is_add_exist_name = e;
        studentApi.studentsAdd(query).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.queryTable()
              this.postData={}
              this.repeatShow = false;
            }else{
              this.$message.error(res.message)
            }  
        });
      }else{
        this.repeatShow = false;
        this.postData={}
      }
    }, 
    seeDetails(){
      this.$router.push({
        path: "/importRecordDetail",
        query: {
          recordId: this.recordId,
          type: 1,
        },
      });
    },
    downloadFailed(){
      // 下载失败数据
      this.$confirm('是否确定导出失败数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        commonApi
            .studentsImportListDetail({
              record_id: this.recordId,
              status: 2,
              limit: 1000,
            })
            .then((res) => {
              if (res.code === 200) {
                console.log("studentsImportListDetail", res.data);
                
                this.popVisible = false;
                this.excelVisible = true;
                this.$message({
                  type: "success",
                  message: res.message,
                });
              }
            });


         
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    async getMe() {
      const res = await commonApi.tobMe();
      if (res.code === 200) {
        // this.myUser = res.data;
        this.role = res.data.role;

        this.is_update_student_teacher = res.data.is_update_student_teacher;
        this.me_id = res.data.id;
        this.me_realname = res.data.realname;

        this.is_test = res.data.group.is_test
        
        this.getAllTeacherList()
        console.log('myUser', res.data, this.is_test)
      }
    },
    getTobSearchCreateUser(keywords) {
      if (keywords.trim().length != 0) {
        commonApi.getTobSearchCreateUser({ keywords }).then((res) => {
          if (res.code == 200) {
            this.createUserOptions = res.data.list;
          }
        });
      }
    },
    // 防抖函数
    debounce(fn, wait) {
      let timeout;
      let _this = this;
      return function (...args) {
        // 清空定时器
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
          fn.apply(_this, args);
        }, wait);
      };
    },
    excelClick() {
      // 数据导出中心
      this.$router.push({
        path: "/cardExportLog",
      });
    },
    async downloadExcel() { 
      // 导出  
      const foo = this.$createElement
      this.$confirm('', {
          message:foo('div',null, [
            // 样式1
            foo('p',{ class: 'el-confirm-span',style:'margin: 10px 0;font-size: 15px;font-weight: bold;color: #191B27;'}, '提示'),
            // 样式2
            foo('i',{ class:'el-icon-question',style:'color: rgb(255, 153, 0); font-size: 20px; vertical-align: middle; margin-top: -3px; margin-right: 5px;' }),
            foo('span',{ style:'margin: 10px 0;color: rgb(25, 27, 39);font-size: 15px;font-weight: bold;' },'是否确认导出导入详情记录数据?'),
            // 样式3
            foo('p',{ style:'margin:10px 15px;color: #191B27;' },'（可按筛选条件导出指定学员数据）')
          ]),
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            customClass:'demo2',
            closeOnClickModal:false,
            closeOnPressEscape:false,
          }).then(() => {
          if(this.queryInfo.tob_good_id){
            this.queryInfo.is_good_filter = 1
          }else{
            this.queryInfo.is_good_filter = 0
          }
          this.queryInfo.app_keys= this.app_keys.toString()
          let query = deepClone(this.queryInfo);
          query.limit = 100000;
          if (this.create_user.length) {
            query.create_user = this.create_user.join(",");
          }
          commonApi.getTobStudents(query).then((res) => {
            if (res.code === 200) {
              this.excelVisible = true; 
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    copy(row){ 
      copyToClip(`${row}`);
      this.$message.success("复制成功！");
    }, 
    syncTopScroll() {
      // 表格顶部滚动条与底部同步
      const scrollLeft = this.tableDom.scrollLeft;
      this.$refs.topScroll.scrollTo(scrollLeft, 0);
    },
    syncTabScroll() {
      // 表格底部滚动条与顶部同步
      const scrollLeft = this.$refs.topScroll.scrollLeft;
      this.$refs.tableRef.bodyWrapper.scrollTo(scrollLeft, 0);
    },
    setScrollWidth() {
      // 设置顶部滚顶条宽度值为表格的滚动宽度
      this.$nextTick(() => {
        this.tableBox = document.getElementsByClassName("table_box")[0];
        this.topScrollBox = document.getElementsByClassName("top-scroll")[0];
        this.tableDom = this.$refs.tableRef.bodyWrapper;
        this.topScrollBox.style.width =
          this.tableBox.getBoundingClientRect().width - 1 + "px"; 
        this.topScrollWidth =
          this.$refs.tableRef.bodyWrapper.scrollWidth + "px"; 
      });
    },
    // handleScroll(e) {
    //   console.log("表头", this.initX);
    //   if (this.tableBox.getBoundingClientRect().y <= 120) {
    //     this.tableWrapper.style.width = this.initX + "px";
    //     this.tableWrapper.style.position = "fixed";
    //     this.tableWrapper.style.top = 120 + "px";
    //     this.tableWrapper.style.zIndex = 2010;
    //   } else {
    //     this.tableWrapper.style.position = "unset";
    //     this.tableWrapper.style.zIndex = "inherit";
    //   }
    // },  
    renderHeader(h, { column }) {
      // console.log('修改表头   slot="reference" style="margin-left: 30px"
      return h("span", [
        h("span", column.label),
        h(
          "el-popover",
          {
            props: {
              placement: "top-start",
              width: "200",
              trigger: "hover",
            },
          },
          [
            h("i", {
              class: "el-icon-question el-icon--right",
              style: "margin-left:5px;cursor:pointer;",
              slot: "reference",
            }),
            h("div", {
              domProps: {
                innerHTML: this.allMoneyTip, // 这里是要渲染的数据
              },
              style: "white-space: pre-line;",
            }),
          ]
        ),
      ]);
    }, 
      
    tableRowClassName({row, rowIndex}) { 
        if ((rowIndex+1)%2==0) {
          return 'warning-row-color';
        }  
        return '';
    },
    confirm() {
      commonApi
        .saveShowFieldConfig({
          type_id:'1',
          show_fields: this.popoverChecked.toString(),
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.revealVisible = false;
            this.queryTable();
          }
        });
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length;
      this.checkAll = checkedCount === this.popoverOptions.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.popoverOptions.length;
    },
    handleCheckAllChange(val) {
      console.log("handleCheckAllChange", val);
      if (val) {
        this.popoverChecked = [];
        this.popoverOptions.forEach((itemA) => {
          this.popoverChecked.push(itemA.field);
        });
      } else {
        this.popoverChecked = [];
      }
      this.checkAll = val;
      this.isIndeterminate = false;
    },

    appKeysChange(e){
      console.log('appKeysChange',e)
      this.appKeysType = e
      this.$forceUpdate() //刷新
    },

    async getTobOpenExams() {
      const res = await goodsApi.getTobOpenExams(this.queryInfo);
      if (res.code == 200) {
        this.examOptionsArr = res.data.exam_list
        console.log("getTobOpenExams---", this.examOptionsArr);
      }
    },

    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(async () => {
          this.loading = false;
          const companyName = query;
          const res = await studentApi.tobGoodList({ good_name: companyName });
          this.options = res.data;
        }, 200);
      } else {
        this.options = [];
      }
    },
    tobGoodList(){ 
      studentApi.tobGoodList().then((res) => {
            if (res.code === 200) {
              this.options = res.data; 
            }
      }); 
    },
    getTobSearchTags(query){
      if (query !== "") {
        this.loading = true;
        setTimeout(async () => {
          this.loading = false;
          const companyName = query;
          commonApi.getTobSearchTags({common_tag_type:2,name: companyName}).then((res) => {
            if (res.code === 200) {
              this.options1 = res.data.data;
              console.log('options1',this.options1) 
            }
          });
       }, 200);
    }
    },
    
    remoteMethod1(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(async () => {
          this.loading = false;
          const companyName = query;
          const res = await studentApi.tobTagsList({ name: companyName });
          this.options1 = res.data.data;
        }, 200);
      } else {
        this.options = [];
      }
    },
    // 列表数据
    async queryTable(_type){
      if(_type){
        this.queryInfo.page = 1
      }
      if(this.queryInfo.tob_good_id){
        this.queryInfo.is_good_filter = 1
      }else{
        this.queryInfo.is_good_filter = 0
      }
      this.queryInfo.app_keys= this.app_keys.toString()

      
      var query = deepClone(this.queryInfo); 
      if (this.create_user.length) {
        query.create_user = this.create_user.join(",");
      }

      const res = await studentApi.studentsList(query)
      if(res.code == 200){
        this.queryInfo.total = res.data.total
        this.tableList = res.data.data
        this.all_self_show_field = res.data.all_self_show_field 
        this.statusOptions = res.data.student_status_list; 
        this.options2 = res.data.jihuo_list
        this.options3 = res.data.exam_list 
        this.addTypeOptions = res.data.add_type_list 
        

        if(res.data.add_type_list && res.data.add_type_list.length > 0){ 
          this.add_type_list = res.data.add_type_list
        }

        this.popoverOptions = []
        if(res.data.all_self_show_field && res.data.all_self_show_field.length > 0){
          this.popoverOptions = res.data.all_self_show_field 
          if(res.data.exam_list.length < 2){
            this.popoverOptions.forEach((item, index) => {
              if(item.field == 'app_names'){
                this.popoverOptions.splice(index, 1);
              }
            }) 
          } 
          console.log("this.popoverOptions", this.popoverOptions)
        }
 
        if(!_type){
          this.popoverChecked = [];
          res.data.all_self_show_field.forEach((item) => {
            if (item.is_selected) {
              this.popoverChecked.push(item.field);
            }
          });
        } 
        if (
          this.popoverChecked.length == res.data.all_self_show_field.length
        ) {
          this.checkAll = true;
        } else {
          this.checkAll = false;
        }
        this.isIndeterminate =
          this.popoverChecked.length > 0 &&
          this.popoverChecked.length < this.popoverOptions.length;  
        this.group_id = res.data.group_id  
        console.log('this.popoverOptions',this.popoverOptions,this.tableList)
      
        setTimeout(() => {
          this.setScrollWidth();
        }, 500);  
      }else{
        this.$message.error(res.message)
      }
    },
    // 打开弹窗
    viewDetail(row){
      // console.log('viewDetail',row,row.mobile) 
        if(row&&row.uid){
          this.isDetail = true
          this.oldMobile = row.mobile
          this.appKeysType = []
          if(row.group_app_list&&row.group_app_list.length>0){
            row.group_app_list.forEach(item => {
              if(item.user_is_kaitong){
                this.appKeysType.push(item.app_type)
              }
            })
          }
          this.examOptions = []
          row.group_app_list.forEach(itemB => {
            if(itemB.app_type_name){ 
              this.examOptions.push({
                key:itemB.app_type,
                value:itemB.app_type_name,
                user_is_jihuo:itemB.user_is_jihuo,
                user_is_kaitong:itemB.user_is_kaitong,
              })
            }
          }) 

          this.teacher_ids = []
          console.log("viewDetail", row.student_teachers)
          if(row.student_teachers&&row.student_teachers.length>0){
            row.student_teachers.forEach(item => {
              this.teacher_ids.push(item.teacher_id)
            })
          } 
   
          this.teacherList = []
          for (let i = 0; i < this.allTeacherList.length; i++) {
            for (let j = 0; j < row.student_teachers.length; j++) {
              if(row.student_teachers[j].teacher_id==this.allTeacherList[i].id){
                this.teacherList.push(this.allTeacherList[i])
              }
            }
          } 
        }else{
          this.isDetail = false   
          this.appKeysType = []
          this.teacher_ids = []
          this.teacherList = [] 
  
          this.examOptions = this.examOptionsArr
          this.examOptions.forEach(itemA => {
            itemA.user_is_kaitong = 0;
            // this.appKeysType.push("senioriup")
            // this.appKeysType.push(itemA.key)
            this.appKeysType = ['senioriup']
          })
        }
        console.log('this.examOptions',row,this.examOptions)
        
      // console.log('oldMobile',this.oldMobile,!this.oldMobile) 

      if(row&&row.uid){
        Object.assign(this.userInfo,row)
      }  
      if(this.is_test == 1){
        if(row&&row.limit_login_device_total){
          this.userInfo.limit_login_device_total = row.limit_login_device_total
        } else { 
          this.userInfo.limit_login_device_total = 1
        } 
      }
 
      //  this.userInfo);
      this.addFormShow = true
    },
    // 添加｜｜修改数据
    addUser(formName){ 
      this.repeatMessage = ''
      if(this.appKeysType.length==0){
        this.$message({
          message: "考试类别必须选一个！",
          type: "error"
        });
        return
      }
      this.userInfo.app_keys = this.appKeysType.toString()  

      if(this.teacherList.length > 0){
        var teacher_ids = []
        for (let i = 0; i < this.teacherList.length; i++) {
          teacher_ids.push(this.teacherList[i].id)
        }
        this.userInfo.teacher_ids = teacher_ids.toString()
      }
      console.log('teacher_ids', this.userInfo.teacher_ids, teacher_ids)
      
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            if(this.antiShaking){
              this.antiShaking = false 
              if(this.userInfo.uid){ 
                if(this.userInfo.mobile!=this.oldMobile){
                  this.$confirm('修改手机号后学员的学习数据以及已购会员权益都会清除，是否继续保存修改', '', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => { 
                    studentApi.studentsEdit(this.userInfo).then(res => {
                      if(res.code == 200){
                        this.$message.success(`${this.dialogType}成功`)
                        this.addFormShow = false
                        this.antiShaking = true  
                        this.tableClear()
                        this.queryTable()
                      }else{
                        this.$message.error(res.message)
                        this.antiShaking = true 
                      }
                    })
                  }).catch(() => {
                    this.$message({
                      type: 'info',
                      message: '已取消'
                    });
                  });
                }else{
                  studentApi.studentsEdit(this.userInfo).then(res => {
                    if(res.code == 200){
                        this.$message.success(`${this.dialogType}成功`)
                        this.addFormShow = false
                        this.antiShaking = true 
                        this.tableClear()
                        this.queryTable()
                      }else{
                        this.$message.error(res.message)
                        this.antiShaking = true 
                      }
                  })
                }
              }else{ 
                await studentApi.studentsAdd(this.userInfo).then(res => {
                  if(res.code == 200){
                    this.$message.success(`${this.dialogType}成功`)
                    this.antiShaking = true 
                    this.addFormShow = false
                    this.queryTable(); 
                    this.tableClear()
                  }else{
                    if(res.data.is_group_exist_realname){
                      this.postData = deepClone(this.userInfo);
                      this.repeatShow = true
                      this.addFormShow = false
                      this.repeatMessage = res.message
                    } else{ 
                      this.$message.error(res.message)
                    }
                    this.antiShaking = true 
                  }
                })
              }
              
            }
          } else {
            //  'error submit!!');
            return false;
          }
        });
    },
    // 设置新密码
    resetCode(row){
      this.resetCodeShow = true
      this.codeInfo.uid = row.uid
    },
    // 删除
    deleteCode(row){
      this.deleteCodeShow = true
      this.deleteCodeData = row
    },
    deleteConfirm(){
      studentApi.studentsDelete({
        uid: this.deleteCodeData.uid
      }).then(res => {
        if(res.code == 200){
            this.$message({
                type: 'success',
                message: res.message
            });
          this.queryTable()
          this.deleteCodeShow = false
        }else{
            this.$message.error(res.message)
        }
      });
    },
    // 禁用
    disableCode(row){
      this.disableCodeShow = true
      this.disableCodeData = row 
    },
    disableConfirm(){
      studentApi.studentsDisable({
        uid: this.disableCodeData.uid
      }).then(res => {
        if(res.code == 200){
            this.$message({
                type: 'success',
                message: res.message
            });
          this.queryTable()
          this.disableCodeShow = false
        }else{
            this.$message.error(res.message)
        }
      });
    },

    // 转移
    moveCode(row){
      console.log('moveCode',row.move_group_id) 
      this.moveData = {}
      this.moveOptions = []
      this.moveCodeShow = true
      this.moveData.uid = row.uid
    }, 

    editMoveCode(row){ 
      console.log('editMoveCode',row.uid,row.move_group_id) 
        studentApi.studentsMove({
          student_uid:row.uid,
          move_group_id: row.move_group_id
        }).then(res => {
          if(res.code == 200){
              this.$message({
                  type: 'success',
                  message: res.message
              });
            this.queryTable()
          }else{
              this.$message.error(res.message)
          }
          this.moveCodeShow = false
          this.moveData = {}
        });  
    },

    // 解绑 
    unbindCode(row){  
      this.$confirm("请确认是否解绑？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => { 
          studentApi.studentsUnbind({
            student_uid: row.uid
          }).then(res => {
            if(res.code == 200){ 
                this.$message({
                    type: 'success',
                    message: '该学员已解绑'
                });  
                this.resetQuery()
            }else{
                this.$message.error(res.message)
            }
          });  
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        }); 
    },  
    editCode(formName){
      this.$refs[formName].validate(async (valid) => {
          if (valid) {
          const res = await studentApi.passwordOperation(this.codeInfo)
          if(res.code == 200){
              this.$message({
                type: 'success',
                message: '修改密码成功!'
              });
            }else{
              this.$message.error(res.message)
            }
            this.resetCodeShow = false
          } else {
            //  'error submit!!');
            return false;
          }
      });
    },
    // 重置密码
    restartCode(row){
      this.$confirm(`是否将用户【${row.realname}】的密码设置为初始密码【${row.default_password}】`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const _obj = {
          uid:row.uid,
          new_password:row.default_password,
          new_password_confirmation:row.default_password
        }
        const res = await studentApi.passwordOperation(_obj)
        if(res.code == 200){
          this.$message({
            type: 'success',
            message: '重置成功!'
          });
        }else{
          this.$message.error(res.message)
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消重置'
        });          
      });
    },
    // 添加、编辑标签
    async editLabel(row){
      this.chioceUid = row.uid
      const res = await studentApi.studentsTags({uid:row.uid})
      if(res.code == 200){
        this.editLabelShow = true
        this.addLabel = res.data.data
        this.userLabel = res.data.own
      }else{
        this.$message.error(res.message)
      }
    },
    // 添加新标签
    async addNewLabelClick(){
      const res = await studentApi.tobTagsAdd({name:this.addNewLabel})
      if(res.code == 200){
        this.$message.success("新增标签成功")
        this.addNewLabel = ''
        const res1 = await studentApi.studentsTags({uid:this.chioceUid})
        if(res1.code == 200){
          this.editLabelShow = true
          this.addLabel = res1.data.data
          this.userLabel.forEach((item,index)=>{
            this.addLabel.forEach((item1,index1)=>{
              if(item.id == item1.id){
                this.addLabel.splice(index1,1)
              }
            })
          })
        }
      }else{
        this.$message.error(res.message)
      }
    },
    // 现有标签选择
    tagAddLabel(tag){
      this.addLabel.forEach((item,index)=>{
        //  'item',item);
          if(item.id == tag.id){
            //  'item',item);
            this.addLabel.splice(index,1)
          }
        })
      if(!this.userLabel.length){
        this.userLabel.push(tag)
        this.userAddLabel.push(tag)
        return
      }
      const _flag = this.userLabel.some((item,index)=>{
        return item.id == tag.id
      })
      if(!_flag){
        //  1111);
        this.userLabel.push(tag)
        this.userAddLabel.push(tag)
      }
    },
    // 删除绑定标签
    deleteLabel(tag){
      this.userLabel.forEach((item,index)=>{
        if(item.id == tag.id){
          this.userLabel.splice(index,1)
        }
      })
      let flag = 0
      this.userAddLabel.forEach((item,index)=>{
        if(item.id == tag.id){
          this.userAddLabel.splice(index,1)
          flag = 1
        }
      })
      let allFlag = 0
      allFlag = this.addLabel.forEach((item,index)=>{
        //  'item',item);
          return item.id == tag.id
        })
      if(!allFlag){
        this.addLabel.push(tag)
      }
      if(!flag){
        const _flag = this.userLabel.some((item,index)=>{
          return item.id == tag.id
        })
        if(!_flag){
          this.userDeleteLabel.push(tag)
        }
      }
    },
    // 用户新增标签
    submitLabel(){
      //  'userAddLabel',this.userAddLabel,'userDeleteLabel',this.userDeleteLabel);
      
      // let _addId = this.userAddLabel.map((item,index)=>{
      //   return item.id
      // })
      let _deleteId = this.userLabel.map((item,index)=>{
        return item.id
      })
      let _proArray = []
      // if(_addId.length){
        _proArray.push(studentApi.studentsTagsAdd({
          uid:this.chioceUid,
          tag_id:_deleteId.join(",") 
        }))
      // }
      // _proArray.push(studentApi.studentsTagsDel({
      //   uid:this.chioceUid,
      //   tag_id:_deleteId.join(",")
      // }))
      Promise.all(_proArray).then(res=>{
        this.queryTable().then(res=>{
          this.$message.success("标签更新成功")
        })
        this.userAddLabel = []
        this.userDeleteLabel = []
        this.editLabelShow = false
      })
    },

    // 开通会员
    buyGoodsBtn(row){
        this.active_status_txt = row.active_status_txt
        this.selectBuyGoodsShow = true
        this.goodsNeedId = row.uid
        console.log('buyGoodsBtn',row)
        this.goodsName = row.realname
    },

    // 跳转已开课程
    skip(row){
      this.$router.push({
        path:'/studentDetail',
        query:{
          name:row.username,
          realname:row.realname,
          uid:row.uid
        }
      })
    },

    // 分页
    handleSizeChange(e){
      //  e);
      this.queryInfo.limit = e
      this.queryTable()
    },
    handleCurrentChange(e){
      this.queryInfo.page = e
      this.queryTable()
    },

    // 批量导入
    // 文件选择回调
    onChange(file, fileList) {
        //  fileList);
        this.fileData = file; // 保存当前选择文件
        this.fileName = file.name
        this.readExcel(); // 调用读取数据的方法
    },
    // 读取数据
    readExcel(e) { 
        const files = this.fileData; 
        if (!files) {
            //如果没有文件
            return false;
        } else if (!/.(xls|xlsx)$/.test(files.name.toLowerCase())) {
            this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
            return false;
        }
        const fileReader = new FileReader();
        let that = this
        fileReader.onload = ev => {
            try {
                const data = ev.target.result;
                console.log('data---',data);
                const workbook = that.XLSX.read(data, {
                    type: "binary",
                    // cellNF:true,
                    raw:true
                });
                console.log('workbook---',workbook);
                // if (workbook.SheetNames.length >= 1) {
                //   this.$message.success("表格导入成功")
                // }
                const wsname = workbook.SheetNames[0]; //取第一张表
                console.log('wsname---',wsname);
                const ws = that.XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //生成json表格内容
                console.log('ws---',ws);
                that.outputs = []; //清空接收数据
                let _list = [] 
                for (var i = 0; i < ws.length; i++) {
                    var sheetData = { 
                        app_keys: ws[i][`考试类别（必填项）
【可选填“高职单招”,“成考”，可多选(用逗号隔开）】`],
                        realname: ws[i][`真实姓名（必填项）
【至少两个中文汉字】`],
                        mobile: ws[i][`手机号（必填项）
【填写后可使用手机号登录】`],
                        id_card: ws[i][`身份证号（非必填项）`],
                        remark: ws[i][`备注（非必填项）`], 
                        tag_ids: ws[i][`标签ID（非必填项）`], 
                        teacher_ids: ws[i][`员工ID（非必填项）`], 
                    };
                  console.log('ws---i',ws[i],ws[i][`员工ID（非必填项）`]);

                    
                    console.log('sheetData',sheetData);
                    _list.unshift(sheetData);
                }
                      console.log('_list',_list);
                if(_list.length){
                      // _list = JSON.stringify(_list)
                      // studentApi.studentsImport({data:_list}).then(res=>{
                      //   if(res.code == 200){
                      //     this.$message.success("导入成功，请查看导入记录")
                      //     this.queryTable()
                      //   }else{
                      //     this.$message.error(res.message)
                      //   }
                      // })
                      this.excelList = _list
                      console.log('this.excelList',this.excelList);
                    }else{
                      this.$message.error("请先填入数据")
                    }
                
                this.$refs.upload.value = "";
            } catch (e) {
                return false;
            }
        };
        // 如果为原生 input 则应是 files[0]
        fileReader.readAsBinaryString(files.raw);
    },
    resetQuery(){
      this.timeFrame = []
      this.app_keys = []
      this.create_user = []
      this.queryInfo = {
        limit:10,
        page:1,
        total:0,
        status:1,//状态 -1全部 1启用 0禁用 
        open_status:'', 
        keyword:"",//用户信息 支持账号真实姓名手机号
        start_time:"",//创建开始时间
        end_time:"",//创建结束时间
        tag_id:"",//标签id
        id_card:"",//身份证号
        tob_good_id:"", //已开通商品
        remark:"", //备注
        // createTime:[]
      }
      this.queryTable()
    },
    // 选择日期
    selectData(e){
      //  e);
      if(e){
        this.queryInfo.start_time = e[0]
        this.queryInfo.end_time = e[1]
      }else{
        this.queryInfo.start_time = ''
        this.queryInfo.end_time = ''
      }
      //  this.queryInfo);
    },
    // timeChange(time) {
    //   if (!time) {
    //     //this.time为绑定的数据
    //     this.queryInfo.createTime = [];
    //   }
    //    this.time)
    // },
    exportExcel() {
      window.open('https://img2.meite.com/questions/studentimport_16_1736392638756.xlsx', '_blank');
    },
    skipImportRecord(row){
      this.$router.push({
        path:"/importRecord",
        query:{
          type:5
        }
      })
    },
    skipImportRecordDetail(recordId){
      this.$router.push({
        path:"/importRecordDetail",
        query:{
          recordId:recordId,
          type:1
        }
      })
    },
    openImport(row){
      this.fileName = ''
      this.excelList = []
      this.outerVisible = true
    },
    studentInvite(){
      // 邀请学员注册
      this.$router.push({
        path:"/extendTool",
        query:{
          activeName:'third' 
        }
      })
    },
    importCheck(){
      if(this.excelList.length){
          this.excelList = JSON.stringify(this.excelList)
        studentApi.importCheck({data:this.excelList}).then(res=>{
          if(res.code == 200){ 
            if(res.data.repeat_group_realname||res.data.repeat_excel_realname){

              this.outerVisible = false;
              this.checkVisible = true;
              this.checkData = res.data;
            }else{

              this.importFile()
            }
            console.log("popData",res.data)
          }else{
            this.$message.error(res.message)
          }
        }) 
      }else{
        this.$message.error("请先填入数据")
      }
    }, 
    importFile(e){ 
      if(this.lockings){
        this.lockings = false
          studentApi.studentsImport({data:this.excelList,is_import_repeat_realname:e}).then(res=>{
            if(res.code == 200){
              // this.$message.success("导入成功，请查看导入记录")
              this.fileName = ''
              this.excelList = []
              this.queryTable()
              this.checkVisible = false 
              this.popVisible = true; 
              this.popData = res.data; 
              this.recordId = res.data.record_id;  
              this.lockings = true
 
              this.tableClear()
            }else{
              this.$message.error(res.message)
              this.lockings = true
            }
          }) 
      }
    },
    excelImport(){
      this.fileName = ''
      this.excelList = []
      this.outerVisible = false
    },
  }
}
</script>

<style lang="less" scoped>
.basicStyle{
  span{
    display: inline-block;
  }
  .querySearch{
    background: #ffffff;
    border-radius: 8px;
    padding: 30px;
    margin-bottom: 12px;
    .searchItem{
      display: inline-block;
      margin: 0 20px 10px 0 ;
      span{
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input{
        width: 230px;
      }
    }
    /deep/ .el-button--primary{
      // margin-left: 50px;
    }
  }
  .addInfo{
    background: #ffffff;
    border-radius: 8px;
    padding: 20px 30px 10px 30px;
    margin-bottom: 12px;
    .el-button{
      margin: 0 20px 10px 0;
    }
  }

  // 表格数据
  .table{
    min-height: calc(100vh - 330px);
    .studentLabel{
      display: inline-block;
      padding: 5px 10px;
      background-color: #409EFF;
      color: #fff;
      border-radius: 4px;
      margin: 0 5px 5px 0;
    }
  }
  .operationItem{
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: #7057FF;
  }
  .operationItem:hover{
    color: red;
  }
  .editColor{
    color: #00C793;
  }

  /deep/ .formDialog{
    .el-select .el-input{
      width: 180px;
    }
    .el-input{
      width: 250px;
    }
    .dialog-footer{
      text-align: center;
    }
  }
}

// 添加标签样式
/deep/ .editLabelClass{
  display: flex;
  align-items: flex-start;
  .p1{
    margin-right: 20px;
    width: 70px;
    line-height: 30px;
  }
  .p2{
    flex: 1;
  }
  .el-tag{
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .searchItem{
    .el-input{
      width: 200px;
      margin: 0 20px;
    }
  }
}
.editLabelClass+.editLabelClass{
  margin-top: 20px;
}
.revealBtn{
  border: 1px solid #9583ff;
  border-radius: 3px;
  color: #9583ff;
}
/deep/ .outerBox{
  width: 356px;
  background: #F7F8FB;
  padding: 5px 6px;
  border-radius: 4px;
  margin-left:30px;
  .el-input__inner{
    border:none;
  }
  .el-input-group__append{
    background: #00C793;
    color: #fff;
    border-radius: 5px;
    border: none;
  }

} 
 
/deep/ .top-scroll {
  overflow-x: auto;
  position: fixed;
  bottom: 20px;
  z-index: 1000;
}
/deep/ .top-scroll::-webkit-scrollbar {
  height: 15px;
}
/deep/ .top-scroll-content {
  /* 高度不设置的话滚动条出不来 */
  height: 1px;
}
/deep/ .illustrate {
  color: #409eff;
  cursor: pointer;
  line-height: 29px;
  margin-bottom: 20px;
}  
.questionIcon {
  width: 19px;
  height: 19px;
  background-image: url("../../assets/new/questionIcon_a1.png");
  background-size: 19px 19px;
  // margin-left: 10px;
}
.questionIcon:hover {
  background-image: url("../../assets/new/questionIcon_a2.png");
  background-size: 19px 19px;
}
.el-icon-success{
  width:50px;
  height:50px;
  font-size:50px;
  color: #67c23a;
  margin-bottom: 20px;
} 
.appRegister{
    display: inline-block;
    line-height: 1;  
    text-align: center; 
    border:1px solid rgb(120, 97, 255);
    color: #333;
    vertical-align: middle;
    border-radius: 4px;
    cursor: pointer; 
    padding: 14px 20px;
    .registerH1{ 
      display: inline-block;
      margin-right:10px;
    }
    .registerH2{ 
      display: inline-block;
      color: rgb(120, 97, 255);
    }
 
}
/deep/ .page_box {
  display: flex; 
  align-items: center;
  padding: 20px;  
  justify-content: space-between;
}
/deep/.kaitong{
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: #999;
    border: 1px solid #999;
    border-radius: 4px;
    font-size: 13px;
    padding: 0 10px;
}
/deep/.xyxq{
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: #00C793; 
    border-radius: 4px;
    font-size: 13px;
    padding: 0 10px; 
}
/deep/.xyxq:hover{ 
  color: red; 
}

/deep/.czbt{
  display: inline-block;
}
/deep/.fg{
  color:#E7EAF0;
  padding:0 10px;
}


/* 针对小屏幕设备（例如手机） */
@media (max-width: 600px) { 
  .czbt{
    display: block!important;
  }
  .fg{
    display: none!important;
  } 

  .page_box{
    display: block;
    .el-pagination{
      display: block;
      width: 100%;

      /deep/.el-pager{
        display: flex;
        flex-wrap: wrap;

         li{
              margin: 4px;
         }
      }

      /deep/.el-pagination__total{
        display: block;

      }
      /deep/.el-pagination__sizes{
        display: block;

      }
      /deep/.btn-prev{
        display: block;

      }
      /deep/.btn-next{
        display: block;

      }
      /deep/.el-pagination__jump{
        display: block;

      } 

    }
  }

}
</style>